import React, { useState, useEffect, useMemo } from "react";
import { Layout, Menu } from "antd";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import MenuItem from "./helper/MenuItem";
import { flattenTree } from "misc/helpfunctions";
import { standardSidebarItems, getSidebarItems } from "./sidebarItems";

const { Sider } = Layout;

const Sidebar = () => {
    const [t] = useTranslation();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    const [openKeys, setOpenKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);

    useEffect(() => {
        const pathname = location.pathname.split("/").filter(element => element !== "");
        setOpenKeys(pathname.map((element, index) => pathname.slice(0, index).join("-")));
        setSelectedKeys(
            flattenTree(standardSidebarItems, "items")
                .filter(item => pathname.join("-").includes(item.key))
                .map(item => item.key)
        );
    }, [location]);

    const onCollapse = collapsed => {
        if (collapsed) {
            setOpenKeys([]);
            setSelectedKeys([]);
        }

        setCollapsed(collapsed);
    };

    return (
        <>
            <Sider collapsible theme="light" collapsed={collapsed} onCollapse={onCollapse} width={280} collapsedWidth={0} trigger={null}>
                <Menu
                    mode="inline"
                    inlineIndent={20}
                    openKeys={openKeys}
                    selectedKeys={selectedKeys}
                    onOpenChange={setOpenKeys}
                    onSelect={({ key }) => setSelectedKeys(key)}
                >
                    {getSidebarItems().map(item => (
                        <MenuItem key={item.key} item={item} />
                    ))}
                </Menu>
            </Sider>
        </>
    );
};

export default Sidebar;
